module.exports = __webpack_public_path__ + "static/media/house4.4e23b7d9.png";